import React from 'react';



// Components
import Bread from '../components/Bread';
import AboutComponent from '../components/About';

const About = () => {
  return (<>
      <Bread title="About Us Techie" des="We are team of talanted designers making Web and Native Apps" />
       <AboutComponent/>
  </>);
}

export default About;
